import type {NotFoundRouteProps, Route} from "@tanstack/react-router";
import {ErrorPageScaffold} from "~/components/pageScaffolds/errorPageScaffold";
import {useIntellsysDevtoolsConfiguration} from "~/contexts/intellsysDevtoolsClientContext";

export function NonEmbeddedNotFoundComponent({data, isNotFound, route, routeId}: NotFoundRouteProps & {route: Route}) {
    const intellsysDevtoolsConfiguration = useIntellsysDevtoolsConfiguration();

    if (intellsysDevtoolsConfiguration.insaneLogs.tanstackRouterDebugging === true) {
        console.info(+new Date(), "tanstackRouterDebugging", route.id, "notFoundComponent");
    }

    if (intellsysDevtoolsConfiguration.insaneLogs.notFoundComponentLogs === true) {
        console.groupCollapsed(+new Date(), "notFoundComponentLogs", route.id, "notFoundComponent");
        console.log("data", data);
        console.log("isNotFound", isNotFound);
        console.log("routeId", routeId);
        console.groupEnd();
    }

    return (
        <>
            <style
                dangerouslySetInnerHTML={{
                    __html: `
                        :root {
                            --gj-signed-out-header-height: 4.375rem;
                            --gj-signed-out-header-height-mobile: 2.75rem;
                            --gj-signed-out-footer-height: 15rem;
                            --gj-signed-out-footer-height-mobile: 31.5rem;
                        }
                    `,
                }}
            />

            <ErrorPageScaffold>
                <div className="h-full grid place-items-center content-center flex-1">
                    <div className="text-[2rem] mb-2">404</div>

                    <div className="mb-16">Page not found</div>

                    {/* TODO: Convert this underline thing into a reusable component or class */}
                    <a
                        href="/u"
                        className="underline hover:text-ae-v0--foreground--600 duration-200"
                    >
                        Back to Home
                    </a>
                </div>
            </ErrorPageScaffold>
        </>
    );
}
